import { jsx } from 'react/jsx-runtime';
import { CheckmarkIcon } from '@flex-design-system/legacy-flex-icons';
import { forwardRef, useMemo, isValidElement } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { SelectOptionIndicator } from './OptionIndicator.mjs';

const OptionTitle = forwardRef(
  ({ children, selectIndicator, ...props }, ref) => {
    const indicator = useMemo(() => {
      return isValidElement(selectIndicator) ? selectIndicator : /* @__PURE__ */ jsx(SelectOptionIndicator, { style: { marginLeft: "auto" }, children: /* @__PURE__ */ jsx(CheckmarkIcon, { color: "green" }) });
    }, [selectIndicator]);
    return /* @__PURE__ */ jsx(Legacy_Dropdown.ItemTitle, { ref, rightSlot: indicator, ...props, children });
  }
);

export { OptionTitle };
//# sourceMappingURL=OptionTitle.mjs.map
